import React, { Component } from "react";
import Modal from "react-modal";
import "../../../src/styles/levelOneWelcomeModal.scss";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class WelcomeLevelTwo extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: true
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <div>
        <Modal
          className="Modal card"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <div className="Welcome-modal-container">
            <h2>
              Now it's time for <span style={{ color: "#52b452" }}>Quiz</span>!
            </h2>

            <img
              src={
                localStorage.getItem("avatar") === "Koala"
                  ? koala
                  : localStorage.getItem("avatar") === "Fox"
                  ? fox
                  : localStorage.getItem("avatar") === "Lemur"
                  ? lemur
                  : localStorage.getItem("avatar") === "Zebra"
                  ? zebra
                  : koala
              }
              alt="Koala"
              width="150pt"
              height="auto"
            />

            <p>
              You will be presented with two consequtive questions and four
              alternatives each. The questions will get harder every{" "}
              <span style={{ fontWeight: 600 }}>round</span>. <br /> <br />
              You can use <span style={{ fontWeight: 600 }}>2 hints</span>{" "}
              during the whole game, use them wisely. Using a hint yields a
              lower score. <span style={{ fontWeight: 600 }}>Good luck!</span>
            </p>

            <button
              className="cta-button"
              onClick={() => {
                this.closeModal();
                this.props.goToLvlTwoQuizOne();
              }}
            >
              Continue
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
